import React from 'react';

import Header from './layouts/Header';
import Preloader from './layouts/Preloader';
import Footer from './layouts/Footer';
import Hero from './sections/Hero';
import Features from './sections/Features';
import Services from './sections/Services';
import Products from './sections/Products';
import Testimonials from './sections/WhyUs';
import Clients from './sections/Clients';
import Contact from './sections/Contact';



class App extends React.Component {
  render() {
    return (
      <div className="App">
        <Header />
        <Hero />
        <Features />
        <Services />
        <Products />
        <Testimonials />
        <Clients />
        <Contact />
        <Preloader />
        <Footer />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js